import apiClient from "./api";

export const exportClientReportLocal = (from, to) => {
  return apiClient.get("/reports/client-sales/export", {
    params: { from, to },
    responseType: "blob",
  });
};

export const exportMarketingReport = (from, to) => {
  return apiClient.get("/reports/marketing/export", {
    params: { from, to },
    responseType: "blob",
  });
};
